import React from 'react'
import cx from 'classnames'

import { NoteWithStat } from 'components/_new/ui'

import s from './NotesWithStatList.scss'


type Note = {
  name: string
  image: string
  productsCount: number
  to?: string
}

type NotesWithStatListProps = {
  items: Note[]
  cards?: boolean
  center?: boolean
  onItemClick?: (name: string) => void
}

const NotesWithStatList: React.FunctionComponent<NotesWithStatListProps> = ({ cards, center, items, onItemClick }) => (
  <div className={cx(s.container)}>
    <div className={cx(s.list, { [s.center]: center })} role="list">
      {
        items.map(({ name, image, productsCount, to }) => (
          <div key={name} className={s.item} role="listitem">
            <NoteWithStat
              className={cx({ [s.card]: Boolean(cards) })}
              name={name}
              image={image}
              productsCount={productsCount}
              to={to}
              onClick={onItemClick}
              dataTestId="popularNote"
            />
          </div>
        ))
      }
    </div>
  </div>
)


export default NotesWithStatList
